import api from '@/client/core/api'
import { PutTableSettingsBody } from '@/typings/twitter_benchmark_campaign_posts'

import { TwBenchmarkApiResponse, TwBenchmarkApiResult, handleApiResponse } from './twBenchmarkApiError'

/**
 * 表示列設定を更新する。body は表示中の列のみを並び順で送る（保存行 = 表示中の列）。
 */
export async function putTwBenchmarkTableSettings(
  groupId: number,
  body: PutTableSettingsBody
): Promise<TwBenchmarkApiResult<boolean>> {
  const response = await api.put<TwBenchmarkApiResponse<boolean>>(
    `/twitter_benchmark_campaign_posts/table_settings/${groupId}`,
    body
  )

  return handleApiResponse<boolean>(response)
}
